import { useSyncExternalStore } from 'react'
import { CollectionState } from '../../../lib'

export function useSelectedField (state: CollectionState) {
  return useSyncExternalStore(
    callback => state.addEventListener('selectedFieldChanged', callback),
    () => state.selectedField
  )
}
